import { Component, OnInit, ViewChild, Input, Output, EventEmitter, ɵConsole } from '@angular/core';

import { WorkflowAutoEmail } from 'app/models/workflow-auto-email';
import { WorkflowWizardService } from 'app/services/workflow-wizard.service';
import { WorkflowAutoEmailService } from 'app/services/workflow-auto-email.service';
import { ModalDirective } from 'ng-uikit-pro-standard';
import { FormGroup, FormArray } from '@angular/forms';
import { WorkflowFile } from 'app/models/workflow-file';
import { AddEmailRuleComponent } from '../add-email-rule/add-email-rule.component';
import { formGroupPatchValueNullFriendly } from 'app/helpers/utils';
import { WorkflowTemplateService } from 'app/services/workflow-template.service';
import { WorkflowForm } from 'app/models/workflow-form';

@Component({
  selector: 'app-email-rules',
  templateUrl: './email-rules.component.html',
  styleUrls: ['./email-rules.component.scss']
})
export class EmailRulesComponent implements OnInit {
  constructor(public workflowWizardService: WorkflowWizardService, private workflowTemplateService: WorkflowTemplateService) { 
    
  }
  
  @Input() workflowStepCompletionFormGroup: FormGroup;
  @Input() forExecution: boolean = false;
  
  autoEmails: WorkflowAutoEmail[] = [];

  allFiles: WorkflowFile[];
  allForms: WorkflowForm[];

  editRuleIndex: number = -1;

  tableLimitSelect = [5, 10, 20, 30, 50, 100];
  selectedAutoEmailTableLimit: number = 5;
  @Input() withTargets = false;

  @ViewChild('addEditEmailRule', { static: true }) addEditEmailRule: AddEmailRuleComponent;

  ngOnInit() {
    this.allFiles = this.workflowTemplateService.getParentFiles(this.workflowStepCompletionFormGroup.root as FormGroup, this.workflowStepCompletionFormGroup.value.name, 
      (this.workflowWizardService.currentStep && this.workflowWizardService.currentStep.value && this.workflowWizardService.currentStep.value.name)? 
          this.workflowWizardService.currentStep.value.name: null);

    this.allForms = this.workflowTemplateService.getParentForms(this.workflowStepCompletionFormGroup.root as FormGroup, this.workflowStepCompletionFormGroup.value.name, 
            (this.workflowWizardService.currentStep && this.workflowWizardService.currentStep.value && this.workflowWizardService.currentStep.value.name)? 
                this.workflowWizardService.currentStep.value.name: null);
                
    this.setAutoEmailsList();
    this.workflowStepCompletionFormGroup.valueChanges.subscribe(()=> {
      this.setAutoEmailsList();
    });
  }

  private setAutoEmailsList() {
      this.autoEmails = this.workflowStepCompletionFormGroup.value.auto_emails;
  }

  editAutoEmailRule(autoEmail: WorkflowAutoEmail, index: number) {
    this.editRuleIndex = index;
    let frmGroup: FormGroup = this.workflowTemplateService.getWorkflowAutoEmailFormGroup(autoEmail, this.forExecution);
    formGroupPatchValueNullFriendly(frmGroup, autoEmail);
    this.addEditEmailRule.show(frmGroup);
  }

  deleteAutoEmailRule(autoEmail: WorkflowAutoEmail, index: number) {
    let autoEmailsFormArray: FormArray = (this.workflowStepCompletionFormGroup.controls['auto_emails'] as FormArray);
    autoEmailsFormArray.removeAt(index);
  }

  onAddEditFinished(frm: FormGroup) {
    let autoEmailsFormArray: FormArray = (this.workflowStepCompletionFormGroup.controls['auto_emails'] as FormArray);

    if (this.editRuleIndex != -1) {
      formGroupPatchValueNullFriendly(autoEmailsFormArray.at(this.editRuleIndex) as FormGroup, frm.value);
      this.editRuleIndex = -1;
    } else {
      autoEmailsFormArray.push(frm);
      frm.setParent(autoEmailsFormArray);
    }
  }
  
  onAddNewRule() {
    this.editRuleIndex = -1;
    let frmGroup: FormGroup = this.workflowTemplateService.getWorkflowAutoEmailFormGroup({} as WorkflowAutoEmail);
    this.addEditEmailRule.show(frmGroup);
  }
}
